module.exports = __webpack_public_path__ + "static/media/team@2x.c0d6731a.png";